import React from "react";
import { connect } from "react-redux";
import { useMountEffect } from "../../../hooks/LifeCycle";
import AutorizacionActions from "../../../stores/autorizacion/Actions";
import CatalogoActions from "../../../stores/catalogo/Actions";
import AutorizacionDiagnosticoForm from "./AutorizacionDiagnosticoForm";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomAlert from "../../../components/Common/CustomAlert";
import CheckRender from "../../../components/Common/CheckRender";
import useEmpresa from "../../../hooks/useEmpresa";
import { columnsAutorizacionesDiagnostico } from "../utils/AutorizacionConstant";
import ModalLoader from "../../../components/Common/ModalLoader";
import CustomModal from "../../../components/CustomModal/CustomModal";
import ModificarDiagnosticoModal from "./ModificarDiagnosticoModal";

const AutorizacionDiagnostico = (props) => {
  const {
    formAutorizacionDiagnosticoData,
    getAutorizacionesDiagnosticoLoading,
    confirmarDiagnosticoDefinitivoLoading,
    modificarDiagnosticoDefinitivoLoading,
  } = props;

  const empresa = useEmpresa();

  useMountEffect(() => {
    props.getDiagnosticos({ Pagina: 1, Tamanio: 10 });
  });

  const openModalModificarDiagnostico = (record) => {
    props.formAutorizacionDiagnostico({
      ...formAutorizacionDiagnosticoData,
      showModalModificarDiagnostico: true,
      diagnosticoModificar: record,
      diagnostico: record?.diagnostico,
    });
  };

  const closeModalModificarDiagnostico = () => {
    props.formAutorizacionDiagnostico({
      ...formAutorizacionDiagnosticoData,
      showModalModificarDiagnostico: false,
    });
  };

  const confirmarDiagnostico = (record) => {
    props.formAutorizacionDiagnostico({
      ...formAutorizacionDiagnosticoData,
      alertConfig: {
        type: "confirm",
        title: "¿Estás seguro?",
        message: `¿Deseas confirmar el diagnóstico definitivo para la autorización ${record?.numeroAutorizacion}?`,
        onConfirm: () => {
          props.confirmarDiagnosticoDefinitivo({
            numeroAutorizacion: record?.numeroAutorizacion,
            formAutorizacionDiagnosticoData,
            formHandler: props.formAutorizacionDiagnostico,
          });
        },
        onCancel: () => {
          props.formAutorizacionDiagnostico({
            ...formAutorizacionDiagnosticoData,
            showAlert: false,
          });
        },
      },
      showAlert: true,
    });
  };

  return (
    <>
      <Section>
        <AutorizacionDiagnosticoForm />
      </Section>

      <CheckRender
        allowed={
          !props.getAutorizacionesDiagnosticoLoading &&
          props?.formAutorizacionDiagnosticoData?.autorizaciones?.length > 0
        }
      >
        <Section>
          <CustomTable
            columns={columnsAutorizacionesDiagnostico(
              confirmarDiagnostico,
              openModalModificarDiagnostico,
              empresa
            )}
            dataSource={formAutorizacionDiagnosticoData?.autorizaciones || []}
            showPagination={true}
            pageSize={10}
            width={"200%"}
            maxWidth={"1200px"}
          />
        </Section>
      </CheckRender>
      <CheckRender
        allowed={
          getAutorizacionesDiagnosticoLoading ||
          confirmarDiagnosticoDefinitivoLoading ||
          modificarDiagnosticoDefinitivoLoading
        }
      >
        <ModalLoader />
      </CheckRender>

      <CheckRender allowed={formAutorizacionDiagnosticoData?.showAlert}>
        <CustomAlert {...formAutorizacionDiagnosticoData?.alertConfig} />
      </CheckRender>

      <CustomModal
        isOpen={formAutorizacionDiagnosticoData?.showModalModificarDiagnostico}
        onClose={closeModalModificarDiagnostico}
      >
        <ModificarDiagnosticoModal />
      </CustomModal>
    </>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formAutorizacionDiagnosticoData:
    state.autorizacion.formAutorizacionDiagnosticoData,
  formAutorizacionDiagnosticoLoading:
    state.autorizacion.formAutorizacionDiagnosticoLoading,

  getAutorizacionesDiagnosticoLoading:
    state.autorizacion.getAutorizacionesDiagnosticoLoading,

  confirmarDiagnosticoDefinitivoLoading:
    state.autorizacion.confirmarDiagnosticoDefinitivoLoading,

  modificarDiagnosticoDefinitivoLoading:
    state.autorizacion.modificarDiagnosticoDefinitivoLoading,
});

const mapDispatchToProps = {
  formAutorizacionDiagnostico: AutorizacionActions.formAutorizacionDiagnostico,
  getAutorizacionesDiagnostico:
    AutorizacionActions.getAutorizacionesDiagnostico,
  confirmarDiagnosticoDefinitivo:
    AutorizacionActions.confirmarDiagnosticoDefinitivo,
  getDiagnosticos: CatalogoActions.getDiagnosticos,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(AutorizacionDiagnostico);
